/* Makeup Geek: one cart line for identical items.
   Shopify splits one cart line into two when the Black Friday free-gift discount only uses part of the quantity
   (for example 3 + 4 of the same powder at the same price). snippets/mg-line-group.liquid shows those lines as ONE line.
   This file makes the quantity buttons, a typed quantity and Remove act on all of them.
   Only rows that carry data-mg-keys are handled here; every other row keeps the theme's own behaviour. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function fire(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
  }

  // Set the TOTAL quantity of a merged row: the first line gets the total, the other lines go to 0.
  function apply(row, total) {
    if (busy) return;
    var keys = (row.getAttribute('data-mg-keys') || '').split(/\s+/).filter(Boolean);
    if (!keys.length) return;
    busy = true;
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    if (total > 0) updates[keys[0]] = total;
    var sections = [];
    fire('cart:push:section.id', { sections: sections });
    fire('theme:loading:doing');
    row.classList.add('hdt-pe-none');
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sections.join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.items && cart.sections) fire('cart:change', { baseEvent: 'line-item:change', cart: cart });
        else document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () { document.dispatchEvent(new CustomEvent('cart:refresh')); })
      .then(function () {
        busy = false;
        row.classList.remove('hdt-pe-none');
        fire('theme:loading:done');
      });
  }

  // Plus / minus / typed quantity: the theme sends a change event from the quantity input.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('input[data-index]')) return;
    var row = input.closest('[data-mg-keys]');
    if (!row) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var n = parseInt(input.value, 10);
    apply(row, isNaN(n) || n < 0 ? 0 : n);
  }, true);

  // Remove link.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('wrapp-remove-item-oncart') : null;
    var row = el && el.closest('[data-mg-keys]');
    if (!row) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    apply(row, 0);
  }, true);
})();
